import { Injectable, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { RequestChangePassword } from '../models/requestChangePassword';
import { AppConfig } from '../config/app-config';
import { Role } from '../models/role';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    @Output() logginEvent: EventEmitter<any> = new EventEmitter();
    constructor(private fb: FormBuilder, private http: HttpClient, private appConfig: AppConfig) { }


    logUser: User;

    comparePasswords(fb: FormGroup) {
        let confirmPswrdCtrl = fb.get('ConfirmPassword');

        if (confirmPswrdCtrl.errors == null || 'passwordMismatch' in confirmPswrdCtrl.errors) {
            if (fb.get('Password').value != confirmPswrdCtrl.value)
                confirmPswrdCtrl.setErrors({ passwordMismatch: true });
            else
                confirmPswrdCtrl.setErrors(null);
        }
    }


    login(formData) {

        return this.http.post(this.appConfig.urlKeysApi + 'User/Login', formData);
    }

    getUser(login: string): Observable<User> {
        
        let params = new HttpParams()
            .set("Login", login ?? '')
        return this.http.get<User>(this.appConfig.urlKeysApi + 'User/GetUser', { params: params });
          
    }

    getUserList() {
        return this.http.get(this.appConfig.urlKeysApi + 'User/GetUserList');
    }
    getRoleList(): Observable<any[]> {
        return this.http.get<any[]>(this.appConfig.urlKeysApi + 'User/GetRolesList');
    }


    saveUser(itemUser: User) {
        return this.http.post(this.appConfig.urlKeysApi + 'User/SaveUser', itemUser);
    }

    deleteUser(itemUser: User) {
        return this.http.post(this.appConfig.urlKeysApi + 'User/DeleteUser', itemUser);
    }

    activateUser(itemUser: User) {
        return this.http.post(this.appConfig.urlKeysApi + 'User/ActivateUser', itemUser);
    }

    unlockUser(itemUser: User) {
        return this.http.post(this.appConfig.urlKeysApi + 'User/UnlockUser', itemUser)
    }

    changePassword(item: RequestChangePassword) {

        return this.http.post(this.appConfig.urlKeysApi + 'User/ChangePassword', item)
    }
}
